export const CENTS_CONVERSION = 100;
